import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useForm} from 'react-hook-form';
import Input from '../../global/Input';
import {showMessageOnError, showMessageOnSuccess} from '../../global/CustomToast';
import {iterateOverKeys} from '../../functions/Global';
import {Mapping, MappingType, resetMappings} from '../../../redux/slices/MappingSlice';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import {useUpdateMappingMutation, useDeleteMappingMutation} from '../../../redux/rtk/injectedMappingApi';
import {moveComments, Person, Process} from '../../functions/GlobalData';
import FormPrompt from '../../global/FormPrompt';
import EditDialogLayout from '../../global/EditDialogLayout';
import {Accordion, AccordionTab} from 'primereact/accordion';
import {PropertyValueForm} from '../PopertyValueForm';
import UnderConstruction from '../../../views/pages/UnderConstruction';
import {CommentForm} from '../CommentForm';
import {TabPanel, TabView} from 'primereact/tabview';
import moment from 'moment';
import StatusLight from '../../global/StatusLight';
import CautionSign from '../../global/CautionSign';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faDatabase,
    faList,
    faMapLocation,
    faPersonCirclePlus,
    faProjectDiagram
} from '@fortawesome/free-solid-svg-icons';
import {ProcessUserMapping} from './ProcessUserMapping';
import {
    useCreateProcessMutation,
    useUpdateArrayMappingMutation,
    useUpdateProcessMutation
} from '../../../redux/rtk/injectedProcessApi';
import {useCleanArray} from '../../hooks/useCleanArray';
import MapOl from '../../geoData/map';
import LayersMapOl from '../../geoData/layer/LayersMapOl';
import BaseLayers from '../../geoData/layer/BaseLayers';
import PoiLayer from '../../geoData/layer/PoiLayer';
import SingleLayer from '../../geoData/layer/SingleLayer';
import geoSettings from '../../../config/geoSettings';
import {PersonMapping} from '../person/PersonMapping';
import {ParcelMapping} from '../parcel/ParcelMapping';
import {LandRegisterMapping} from '../landRegister/LandRegisterMapping';
import {MeasureOverview} from '../../projectMasterData/measure/MeasureOverview';
import {UtilisationOverview} from '../../projectMasterData/utilisation/UtilisationOverview';
import {PersonOverview} from '../person/PersonOverview';
import {ParcelOverview} from '../parcel/ParcelOverview';
import {LandRegisterOverview} from '../landRegister/LandRegisterOverview';
import {RadioButton} from 'primereact/radiobutton';
import {useGetBundeslandQuery} from '../../../redux/rtk/injectedIsoBundeslandApi';
import {checkPermission} from '../../../functions/functionLibrary';
import {permissions} from '../../../config/permissions';

type Props = {
    projectId: string,
    data: any,
    setIsDirty: (isDirty: boolean) => void
    // eslint-disable-next-line react/no-unused-prop-types
    onFinished: (success: any) => void,
    geodata: any
}

export const ProcessEditForm = (props: Props): JSX.Element => {
    console.log(props);
    const {t} = useTranslation(['common', 'stammdaten']);

    const mappings: Mapping[] = useAppSelector((state: any) => state.mappingData.mappings);
    const dispatch = useAppDispatch();
    const [updateMapping] = useUpdateMappingMutation();
    const [deleteMapping] = useDeleteMappingMutation();
    const [mappingChanged, setMappingChanged] = useState<boolean>(false);

    const [createProcess, resultCreate] = useCreateProcessMutation();
    const [updateProcess, resultUpdate] = useUpdateProcessMutation();
    const [updateProcessMapping, resultUpateMapping] = useUpdateArrayMappingMutation();

    const [data, setData] = useState(props.data);
    const [formData, setFormData] = useState<FormData>();
    const [showUpdateDialog, setShowUpdateDialog] = useState<boolean>(false);
    const [suggestionData, setSuggestionData] = useState<any[]>([]);
    const [selectedSuggestion, setSelectedSuggestion] = useState<Person[]>([]);
    const [height, setHeight] = useState<number>(0);


    // const [selectedVerhandler, setSelectedVerhandler] = useState<any[]>([]);
    // const [selectedSachbearbeiter, setSelectedSachbearbeiter] = useState<any[]>([]);

    const divRef: any = useRef(null);

    const isCleaned = useCleanArray(formData, {
        project_id: props.projectId !== '' ? props.projectId : null
    }, true);

    const {data: bundeslandQuery = [], isLoading} = useGetBundeslandQuery();

    const countryIsoList = [{
        label: <div className={'flex'}><img className={'mr-1'}
                                            src={'/images/wappen/deutschland.svg'}
                                            width={25}
                                            height={25}/>
            <div className={'my-auto'}>Deutschland</div>
        </div>, value: 'Deutschland'
    }];


    const defaultValues: Process = {
        vorgang_id: props.data ? props.data.vorgang_id : '',
        active: props.data ? props.data.active : false,
        land_iso: props.data ? props.data.land_iso : '',
        land_name: props.data ? props.data.land_name : '',
        b_land_iso: props.data ? props.data.b_land_iso : '',
        b_land_name: props.data ? props.data.b_land_name : '',
        dmt_es_id: props.data ? props.data.dmt_es_id : '',
        kommentar: '',
        kommentare: props.data ? props.data.kommentare : [],
        status_id: props.data ? props.data.status_id : 0,
        vorhabentraeger_id: props.data ? props.data.vorhabentraeger_id : '',
        zeitstempel: props.data ? props.data.zeitstempel : '',
    };

    const {control, formState: {errors, isDirty}, handleSubmit, getValues, setValue, watch} = useForm({defaultValues});

    const active = watch('active');
    const kommentare = watch('kommentare');
    const statusId = watch('status_id');

    const saveData = (data: any, event: any) => {
        data = iterateOverKeys(data);
        data.project_id = props.projectId;
        setFormData(data);
    };

    const getFormErrorMessage = (name: string) => {
        // @ts-ignore
        return errors[name] && <small className="p-error custom">{errors[name].message}</small>;
    };

    useEffect(() => {
        dispatch(resetMappings());
    }, []);


    useEffect(() => {
        if (divRef.current) {
            setHeight(divRef.current.parentElement.clientHeight);
        }
    }, [divRef.current]);

    useEffect(() => {
        if (typeof formData !== 'undefined') {

            // const users = selectedVerhandler.concat(selectedSachbearbeiter);

            if (props.data) {
                updateProcess(formData).then(async (result: any) => {
                    // if (!result.error) {
                    // updateProcessMapping({
                    //     project_id: props.projectId,
                    //     vorgang_id: props.data.id,
                    //     mapping_type: 'vorgang_user',
                    //     users: users
                    // });
                    showMessageOnSuccess(t('globalData:process.processUpdated'), '');
                    moveComments(getValues, setValue);
                    props.onFinished(formData);

                    // }
                });
            } else {
                createProcess(formData).then(async (result: any) => {
                    // if (!result.error) {
                    // updateProcessMapping({
                    //     project_id: props.projectId,
                    //     vorgang_id: result.data.id,
                    //     mapping_type: 'vorgang_user',
                    //     users: users
                    // });
                    showMessageOnSuccess(t('globalData:process.processUpdated'), '');
                    moveComments(getValues, setValue);
                    props.onFinished(formData);
                    // }
                });
            }
        }
    }, [formData]);

    useEffect(() => {
        setShowUpdateDialog(suggestionData.length > 0);
    }, [suggestionData]);

    const hideUpdateDialog = () => {
        setShowUpdateDialog(false);
    };

    const onSelection = (selection: Person[]) => {
        setSelectedSuggestion(selection);
    };

    useEffect(() => {
        props.setIsDirty(isDirty || mappingChanged);
    }, [isDirty, mappingChanged]);

    const getStatus = () => {
        return (
            <StatusLight id={'statuslight-parceleditform'} value={statusId} info={'Testinfo'} light={false}
                         horizontal={false} caution={false}/>);
    };

    // Accordion Headlines --->

    const getCommentAccordionHeadline = () => {
        let right = '';

        if (kommentare && kommentare.length > 0) {
            right = t('lastEntry') + ': ' + moment(kommentare[0].zeitstempel).format(t('datetimeformat'));
        }

        return (<div className={'grid grid-nogutter'}>
            <div
                className={'col'}>{t('comments') + (kommentare && kommentare.length > 0 ? ` (${kommentare.length})` : '')}</div>
            <div className={'col-auto text-right'}>{right}</div>
        </div>);
    };

    // <--- Accordion Headlines

    return (<div className={'relative h-full'}>
        <form ref={divRef} id="editProcessForm" onSubmit={handleSubmit(saveData)} className={'h-full'}>
            <FormPrompt hasUnsavedChanges={isDirty || mappingChanged}/>
            <EditDialogLayout left={<>
                <div className={'grid'}>
                    <div className={'col-12 md:col-6 grid grid-nogutter'}>
                        <div className={'col-fixed'}>
                            {getStatus()}
                        </div>
                        <div className={'col'}>
                            <div className={'p-1'}>
                                <RadioButton className={'mr-2'}
                                             inputId={'active_true'}
                                             value={false} name="active"
                                             onChange={() => {
                                                 setValue('active', true);
                                             }}
                                             checked={active}/>
                                <label
                                    htmlFor="active_true">{t('active')}</label>
                            </div>
                            <div className={'p-1'}>
                                <RadioButton className={'mr-2'}
                                             inputId={'active_false'}
                                             value={true}
                                             name="ist_juristisch"
                                             onChange={() => {
                                                 setValue('active', false);
                                             }}
                                             checked={!active}/>
                                <label
                                    htmlFor="active_false">{t('inactive')}</label>
                            </div>
                        </div>
                    </div>
                    <div className={'col-12 md:col-6'}>
                        <Input
                            edit={false} label={t('globalData:process.columns.dmt_es_id')} name={'dmt_es_id'}
                            validationControl={control} validationErrorMessage={getFormErrorMessage}
                            validationRules={{
                                required: false
                                // required: t('globalData:process.dmt_es_id') + ' ' + t('input:required')
                            }}
                        />
                    </div>
                </div>
                <div className={'grid'}>
                    <div className={'col-12 md:col-6'}>
                        <Input
                            edit={checkPermission(permissions.editProcess)} label={t('globalData:parcels.countryIso')}
                            name={'land_name'}
                            value={props.data ? props.data.land_name : undefined}
                            type={'dropdown'}
                            disabled={true}
                            dropdownOptions={countryIsoList}
                            validationControl={control} validationErrorMessage={getFormErrorMessage}
                            validationRules={{
                                required: false,
                            }}
                        />
                    </div>
                    <div className={'col-12 md:col-6'}><Input
                        edit={checkPermission(permissions.editProcess)} label={t('globalData:parcels.stateIso')}
                        name={'b_land_iso'}
                        type={'dropdown'}
                        disabled={true}
                        dropdownOptions={bundeslandQuery.map((item: any) => {
                            return {
                                value: item.id, label: <div className={'flex'}><img className={'mr-1'}
                                                                                    src={`/images/wappen/${item.id}.svg`}
                                                                                    width={25}
                                                                                    height={25}/>
                                    <div className={'my-auto'}>{item.name}</div>
                                </div>,
                            };
                        })}
                        validationControl={control} validationErrorMessage={getFormErrorMessage}
                        validationRules={{
                            required: false,
                        }}
                    />
                    </div>
                </div>
                <div className={'grid'}>
                    <div className={'col-12 md:col-6'}>
                        <Input
                            edit={checkPermission(permissions.editProcess)}
                            label={t('globalData:process.columns.vorhabentraeger_id')}
                            name={'vorhabentraeger_id'}
                            validationControl={control} validationErrorMessage={getFormErrorMessage}
                            validationRules={{
                                required: false,
                            }}
                        />
                    </div>
                </div>
                <hr/>
                {/*<Accordion>*/}
                {/*    <AccordionTab header={t('mappings')}>*/}
                {/*        <div className={'p-2'}>*/}
                {/*            <ProcessUserMapping projectId={props.projectId}*/}
                {/*                                roleName={'Verhandler'}*/}
                {/*                                onSelection={(selectedItems, haupt) => {*/}
                {/*                                    setSelectedVerhandler(selectedItems.map((item) => {*/}
                {/*                                        return {*/}
                {/*                                            user_id: item,*/}
                {/*                                            role_name: 'Verhandler',*/}
                {/*                                            hat_hauptrolle: item === haupt*/}
                {/*                                        };*/}
                {/*                                    }));*/}
                {/*                                }}/>*/}
                {/*        </div>*/}
                {/*        <div className={'p-2'}>*/}
                {/*            <ProcessUserMapping projectId={props.projectId}*/}
                {/*                                roleName={'Sachbearbeiter'}*/}
                {/*                                onSelection={(selectedItems, haupt) => {*/}
                {/*                                    setSelectedSachbearbeiter(selectedItems.map((item) => {*/}
                {/*                                        return {*/}
                {/*                                            user_id: item,*/}
                {/*                                            role_name: 'Sachbearbeiter',*/}
                {/*                                            hat_hauptrolle: item === haupt*/}
                {/*                                        };*/}
                {/*                                    }));*/}
                {/*                                }}/>*/}
                {/*        </div>*/}
                {/*    </AccordionTab>*/}
                {/*</Accordion>*/}
                {/*<br/>*/}
                <Accordion>
                    <AccordionTab
                        header={getCommentAccordionHeadline()}>
                        <CommentForm projectId={props.projectId} t={t} type={'vorgang'}
                                     getFormErrorMessage={getFormErrorMessage}
                                     form={{
                                         control,
                                         formState: {errors},
                                         handleSubmit,
                                         setValue,
                                         getValues,
                                         watch
                                     }} edit={checkPermission(permissions.editProcess)}
                                     kommentare={kommentare}/>
                    </AccordionTab>
                </Accordion>
                <br/>
                <Accordion>
                    <AccordionTab header={t('documents')}>
                        <UnderConstruction/>
                    </AccordionTab>
                </Accordion>
            </>} right={<TabView activeIndex={1} renderActiveOnly={false}>
                <TabPanel header={<div><FontAwesomeIcon className="sidebar-icon mr-2"
                                                        icon={faDatabase}/>{t('tabs.relationshipProjectMasterData')}
                </div>}>
                    <br/>
                    <Accordion activeIndex={0}>
                        <AccordionTab header={t('projectMasterData:measures.plural')}>
                            <MeasureOverview
                                projectId={props.projectId}
                                mapping={data ? {vorgang_id: data.vorgang_id} : {}}
                                editable={false}
                                expandable={false}
                                hideGlobalFilter={false}
                                showColumnFilters={true}
                                hideButtons={true}
                                skeletonCount={1}
                                showHeader={false}
                            />
                        </AccordionTab>
                    </Accordion>
                    <br/>
                    <Accordion activeIndex={0}>
                        <AccordionTab header={t('projectMasterData:utilisation.plural')}>
                            <UtilisationOverview
                                projectId={props.projectId}
                                mapping={data ? {vorgang_id: data.vorgang_id} : {}}
                                editable={false}
                                expandable={false}
                                hideGlobalFilter={false}
                                showColumnFilters={true}
                                hideButtons={true}
                                skeletonCount={1}
                                showHeader={false}
                            />
                        </AccordionTab>
                    </Accordion>
                </TabPanel>
                <TabPanel header={<div><FontAwesomeIcon className="sidebar-icon mr-2"
                                                        icon={faProjectDiagram}/>{t('tabs.relationshipProjectProcessing')}
                </div>}>
                    <br/>
                    <Accordion activeIndex={0}>
                        <AccordionTab header={t('globalData:global.personen')}>
                            <PersonOverview projectId={props.projectId} editable={false} expandable={false}
                                            hideGlobalFilter={false} commonData={true}
                                            showParcels={false} showPersons={false} showLandRegisters={false}
                                            showShareInfos={false}
                                            showSuggestions={false} showColumnFilters={false} hideButtons={false}
                                            hideAddButton={true}
                                            processId={props.data ? props.data.vorgang_id : ''}
                                            selectable={true}
                                            multiSelection={true}
                                            geoData={props.geodata}
                                            mapping={props.data ? {'vorgang_id': props.data.vorgang_id} : {}}
                                            ableToUpdate={false}
                                            isDirty={isDirty}/>
                        </AccordionTab>
                    </Accordion>
                    <br/>
                    <Accordion activeIndex={0}>
                        <AccordionTab header={t('globalData:global.flurstuecke')}>
                            <ParcelOverview projectId={props.projectId} editable={false} expandable={false}
                                            hideGlobalFilter={false} commonData={true} showColumnFilters={false}
                                            showPersons={false}
                                            showLandRegisters={false} showShareInfos={false}
                                            showUtilisationInfo={false}
                                            hideButtons={true}
                                            geoData={props.geodata}
                                            processId={props.data ? props.data.vorgang_id : ''}
                                            mapping={props.data ? {'vorgang_id': props.data.vorgang_id} : {}}
                                            ableToUpdate={false}
                                            isDirty={isDirty}/>
                            {/*    <ParcelMapping projectId={props.projectId}*/}
                            {/*    mappingId={data ? data.id : ''}*/}
                            {/*    mappingType={MappingType.process}*/}
                            {/*    // dataIds={data && data.flurstueck ? data.flurstueck : []}*/}
                            {/*    // scrollHeight={`${height / 3 - 150}px`}*/}
                            {/*    showHeader={false} skip={!data}*/}
                            {/*    onChange={() => {*/}
                            {/*    setMappingChanged*/}
                            {/*    (*/}
                            {/*    true);*/}
                            {/*}}*/}
                            {/*    isDirty={isDirty || mappingChanged}/>*/}
                        </AccordionTab>
                    </Accordion>
                    <br/>
                    <Accordion activeIndex={0}>
                        <AccordionTab header={t('globalData:global.landRegisters')}>
                            <LandRegisterOverview projectId={props.projectId} expandable={false} editable={false}
                                                  hideGlobalFilter={false}
                                                  commonData={true} showColumnFilters={false} showParcels={false}
                                                  showPersons={false} hideButtons={true}
                                                  processId={props.data ? props.data.vorgang_id : ''}
                                                  ableToUpdate={false}
                                                  showShareInfos={false} geoData={undefined}
                                                  mapping={props.data ? {'vorgang_id': props.data.vorgang_id} : {}}
                                                  isDirty={isDirty}/>
                        </AccordionTab>
                    </Accordion>
                    <br/>
                    <Accordion>
                        <AccordionTab header={t('globalData:global.ecoAccounts')}>
                            <UnderConstruction/>
                        </AccordionTab>
                    </Accordion>
                    <br/>
                    <Accordion>
                        <AccordionTab header={t('globalData:global.research')}>
                            <UnderConstruction/>
                        </AccordionTab>
                    </Accordion>
                    <br/>
                    <Accordion>
                        <AccordionTab header={t('correspondence:plural')}>
                            <UnderConstruction/>
                        </AccordionTab>
                    </Accordion>
                    <br/>
                    <Accordion>
                        <AccordionTab header={t('contract:pluralShort')}>
                            <UnderConstruction/>
                        </AccordionTab>
                    </Accordion>
                    <br/>
                    <Accordion>
                        <AccordionTab header={t('globalData:global.legalProceedings')}>
                            <UnderConstruction/>
                        </AccordionTab>
                    </Accordion>
                    <br/>
                    <Accordion>
                        <AccordionTab header={t('payment:plural')}>
                            <UnderConstruction/>
                        </AccordionTab>
                    </Accordion>
                    <br/>
                    <Accordion>
                        <AccordionTab header={t('invoice:plural')}>
                            <UnderConstruction/>
                        </AccordionTab>
                    </Accordion>
                </TabPanel>
                <TabPanel header={<div><FontAwesomeIcon className="sidebar-icon mr-2"
                                                        icon={faList}/>{t('tabs.relationshipProjectManagement')}
                </div>}>
                </TabPanel>
            </TabView>}/>
        </form>
    </div>);
};
